import * as messages from "../../messages";
import { AgencyWithIsChatOnly } from "../../messages/Agency";
import { CaregiverStatus } from "../../messages/CaregiverStatus";
import { AgencyId, AgencyMemberId } from "../../messages/ObjectIds";
import { genericUpdate } from "../../utils/generic_update";
import { HashMap } from "../../utils/HashMap";

export interface AppAgenciesState {
  readonly agencies: HashMap<AgencyId, AgencyWithChatOnlyDetails>;
  readonly allAgencyMembers: HashMap<AgencyMemberId, AgencyMember>;
}

export interface Agency {
  readonly id: AgencyId;
  readonly status: CaregiverStatus;
  readonly agency: messages.Agency;
  readonly agencyMembers: HashMap<AgencyMemberId, messages.AgencyMember>;
}

export interface AgencyWithChatOnlyDetails extends Omit<Agency, "agency"> {
  readonly agency: AgencyWithIsChatOnly;
}

export interface AgencyMember {
  readonly agencyId: AgencyId;
  readonly details: messages.AgencyMember;
}

export class AppAgenciesState {
  static fromMessage(message: messages.CaregiverAgencyMembers): AppAgenciesState {
    let agencies = HashMap.empty<AgencyId, AgencyWithChatOnlyDetails>();
    let allAgencyMembers = HashMap.empty<AgencyMemberId, AgencyMember>();

    for (const agency of message.agencies) {
      let agencyAgencyMembers = HashMap.empty<AgencyMemberId, messages.AgencyMember>();
      for (const agencyMember of agency.agencyMembers) {
        agencyAgencyMembers = agencyAgencyMembers.set(agencyMember.id, agencyMember);

        allAgencyMembers = allAgencyMembers.set(agencyMember.id, {
          agencyId: agency.agency.id,
          details: agencyMember,
        });
      }

      agencies = agencies.set(agency.agency.id, {
        id: agency.agency.id,
        agency: agency.agency,
        agencyMembers: agencyAgencyMembers,
        status: agency.status,
      });
    }

    return {
      agencies: agencies,
      allAgencyMembers: allAgencyMembers,
    };
  }

  static updateFromMessage(
    appAgenciesState: AppAgenciesState,
    message: messages.CaregiverAgencyMembers
  ): AppAgenciesState {
    return genericUpdate(appAgenciesState, AppAgenciesState.fromMessage(message));
  }
}
